import styled from 'styled-components'

interface IProps {
  size?: number
  className?: string
  message: string | number
}

export const ErrorMessage = ({ className, size = 1, message }: IProps) => {
  return (
    <Span data-testid="error-message-container" size={size} className={className}>
      {message}
    </Span>
  )
}

const Span = styled.span<{ size: number }>`
  display: inline-block;
  white-space: normal;
  color: ${({ theme }) => theme.colors.error.dark};
  font-size: ${({ size, theme }) => `calc(${theme.spacing.s} * ${size})`};
`
